import  { api } from "@/services/api";
import { mapMutations, mapState, mapGetters } from "vuex";

export const locationMixins = {
  data: () => ({
    locationGps: {  longitud:"",latitud:"" },
    citysGhost: [],
    alertPolygon: false,
    address: "",
    placeFound: { place_id: null },
    city: null,
    zones: [],
    loading: false
  }),
  computed: {
    ...mapState('order',["purchaseId","shoppingCart","subservice"]),
    ...mapState('profile', ["session","location","place","supplierAvailability","locationGhost"]),
    ...mapState('customer', ["instance", "polygon","supplier"]),
    ...mapState('shared', [ "mainCategoryId" ]),
    ...mapState('delivery', [ "zone","citys","cutleryStore","packedStore" ]),
    ...mapGetters('customer', ["getLabels","price_currency_locale"])
  },
  methods: {
    ...mapMutations('customer', ["SetPolygon", "SetSupplier"]),
    ...mapMutations('profile', ["setLocation", "setPlace","setSupplierAvailability","setLocationGhost"]),
    ...mapMutations('order', ['setShoppingCart']),
    ...mapMutations('shared', ['setCoupon','SetProductId','setProductGhost']),
    ...mapMutations('delivery', ['setZone','setCitys']),
    async validateLocation() {
      try {
        const responseSupplierAvailability = await api.getSupplierAvailable();
        if (responseSupplierAvailability) {
          this.SetPolygon(responseSupplierAvailability.data.polygon);
          this.setSupplierAvailability({
            selected: true,
            data: responseSupplierAvailability.data
          });
          this.getInfoSucursal(responseSupplierAvailability.data.supplier_id);
          this.loading = false;
        };
      } catch (error) {
        console.error(error);
        this.loading = false;
        this.alertPolygon = true;
      };
    },
    async getInfoSucursal(supplier_id) {
      try {
        const response = await api.getInfoSucursal(supplier_id);
        if (response.data.id) {
          this.zones = response.data.shipping_price;
          this.SetSupplier(response.data);
        };
      } catch (error) {
        console.error(error);
        this.alertPolygon = true;
      };
    },
    async getCitys() {
      try {
        const response = await api.getCitys();
        if (response) {
          this.citysGhost = response.data;
          this.setCitys(response.data);
          if (!this.city && this.supplierAvailability.data && this.supplierAvailability.data.ciudad_id) this.city = this.citys.find(element => element.id === this.supplierAvailability.data.ciudad_id);
          if (this.$route.name === 'Location' && (!this.location || this.location && !this.location.address)) this.oneCityRedirec(this.citysGhost);
        };
      } catch (error) {
        console.error(error);
      };
    },
    setDataLocation() {
      let dataLocation = {
        latitude: this.locationGps.latitud ,
        longitude: this.locationGps.longitud,
        address: this.address,
        address_optional: this.infoOpcional,
        optional: this.infoOpcional,
        addressSetUser: this.address,
        formatted_address: this.place?.formatted_address,
        city: this.city,
        place_id: this.place?.place_id,
        location_price: (this.polygon !== null && this.polygon.polygon_found !== null || this.zone !== null) ? (this.polygon?.delivery_price || this.zone?.value) : null,
        supplier_id: this.supplier ? this.supplier.id : null,
        polygon_id: this.polygon !== null && this.polygon.active ? this.polygon.id : null
      };
      this.setLocation(dataLocation);
    },
    oneCityRedirec (citys) {
      if (citys && citys.length > 1) {
        this.modalGps = true;
      } else if (citys && citys.length === 1) {
        this.city = citys[0];
        if (!this.location || this.location && !this.location.address) {
          this.setLocations(this.city);
          this.getInfoSucursal(citys[0].supplier_id);
          setTimeout(() => this.goToHomeDelivery(), 1000);
        } else {
          this.modalGps = true;
        };
      } else {
        (citys);
      };
    },
    setLocations (city) {
      this.setLocationGhost({
        city: city,
        supplier_id: city.supplier_id,
        latitude: city.latitud,
        longitude: city.longitud
      });
      this.setLocation({
        city: city,
        supplier_id: city.supplier_id,
        latitude: city.latitud,
        longitude: city.longitud
      });
    }
  }
}